import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {Button, Input, Switch} from 'antd';
import {DropdownSelector} from '../Widgets';
import {ErrParamTypeNotAvailable} from '../errors';
const appConfig = require('../data.json');

function OptionBtn({label, selected, onClick}) {
  const selectedProps = selected ? {type: 'primary'} : {};
  return (
    <Button
      style={{
        marginRight: 8,
        marginBottom: 8,
        padding: '5px 16px',
        height: 'auto',
      }}
      onClick={onClick}
      {...selectedProps}>
      {label}
    </Button>
  );
}

function isRangeOptionSelected(num, option) {
  return (
    num && Number(option.range_from) <= num && num <= Number(option.range_to)
  );
}

function parseMasterOption(option) {
  return {
    ...option,
    quantityOptions: option.range.split(',').map((value) => {
      let [from, to] = value.split('-');
      return {
        range_from: parseInt(from),
        range_to: parseInt(to),
      };
    }),
    sizeOptions: option.support_size.split(','),
  };
}

function findExtraDisplayInfo(param, value, config) {
  const options = param.options;
  const extra = {};

  if (options && Array.isArray(options)) {
    let selectedOption = null;
    if (param.type === 'single') {
      selectedOption = options.find((opt) => opt.name === value);
    } else if (param.type === 'master') {
      selectedOption = options.find((opt) => opt.name === value.name);
    } else if (param.type === 'group-number') {
      selectedOption = options.find((opt) => opt.name === value.name);
    }

    if (selectedOption) {
      if (selectedOption.open_template_day) {
        extra.open_template_day = selectedOption.open_template_day;
      } else if (selectedOption.original_price) {
        extra.original_price = selectedOption.original_price;
      }

      if (
        config.side_select === 'single' &&
        selectedOption.single_original_price
      ) {
        extra.original_price = selectedOption.single_original_price;
      } else if (
        config.side_select === 'double' &&
        selectedOption.double_original_price
      ) {
        extra.original_price = selectedOption.double_original_price;
      }
    }
  }

  return extra;
}

function getDefaultConfigWithExtra({product, side, material}) {
  const selectNames = getProductSelectNames(product);
  const defaultValues = {};
  let extra = {};
  let currSelectName = null;
  try {
    if (side === undefined) {
      side = null;
      if (selectNames.indexOf('side_select') > -1) {
        defaultValues['side_select'] = product.side_select.options[0].name;
      }
    }

    if (product?.open_template_day) {
      extra.open_template_day = product.open_template_day;
    }

    for (let selectName of selectNames) {
      if (selectName === 'side_select') {
        continue;
      }

      currSelectName = selectName;
      const param = filterParamOptionsWithSide({
        side: side || defaultValues['side_select'],
        param: product[selectName],
      });

      if (param.type === 'single') {
        defaultValues[selectName] = param.options[0].name;
      } else if (param.type === 'multiple') {
        defaultValues[selectName] = [];
      } else if (param.type === 'number') {
        defaultValues[selectName] = Number(param.options[0].range_from);
      } else if (param.type === 'boolean') {
        defaultValues[selectName] = false;
      } else if (param.type === 'group-number') {
        defaultValues[selectName] = {
          name: param.options[0].name,
          quantity: Number(param.options[0].range_from),
        };
      } else if (param.type === 'master') {
        const selectedMasterOption =
          param.options.find((opt) => opt.material === material) ||
          param.options[0];
        const masterSelect = parseMasterOption(selectedMasterOption);
        defaultValues[selectName] = {
          material: masterSelect.material,
          quantity: masterSelect.quantityOptions[0].range_from,
          size: masterSelect.sizeOptions[0],
        };
      } else {
        throw new ErrParamTypeNotAvailable('no param type');
      }

      const nextExtra = findExtraDisplayInfo(
        param,
        defaultValues[selectName],
        defaultValues,
      );

      extra = {
        ...nextExtra,
        ...extra,
      };
    }
  } catch (ex) {
    if (typeof window === 'object') {
      alert(`Spec Error for ${product.name}:${currSelectName}`);
    }
  }

  return [defaultValues, extra];
}

function getProductSelectNames(product) {
  const selectAttrs = [];
  for (let attr in product) {
    if (attr.indexOf('_select') > -1 && product[attr] !== null) {
      selectAttrs.push(attr);
    }
  }

  //filter and sort
  const ordering = product?.order || ['*', 'length_select', 'width_select'];
  const index = ordering.indexOf('*') <= 0 ? 0 : ordering.indexOf('*');
  selectAttrs.sort((a, b) => {
    let indexA = ordering.indexOf(a) >= 0 ? ordering.indexOf(a) : index;
    let indexB = ordering.indexOf(b) >= 0 ? ordering.indexOf(b) : index;
    return indexA - indexB;
  });
  return selectAttrs;
}

function filterParamOptionsWithSide({side, param}) {
  if (!side) {
    return param;
  }

  let options = param.options;
  if (side === 'single') {
    options = param.options.filter((option) => {
      if (typeof option.support_single === 'boolean') {
        return option.support_single;
      }
      return true;
    });
  } else if (side === 'double') {
    options = param.options.filter((option) => {
      if (typeof option.support_double === 'boolean') {
        return option.support_double;
      }
      return true;
    });
  }

  return {
    ...param,
    options,
  };
}

function checkIfDisabled(o, config) {
  // o is an option or a field
  // config = {
  //   structure_select_1: "黑"
  //   structure_select_2: "夏芽卡"
  //   structure_select_3: "無"
  // }
  if (o.exclude) {
    let otherFields = o.exclude.split(';');
    let re = /^(.*)\[(.*)\]$/;
    if (otherFields.length > 0) {
      for (const field of otherFields) {
        if (re.test(field)) {
          let group = field.match(re);
          let excludeKey = group[1];
          let excludeOptions = group[2].split(',');

          if (
            Array.isArray(excludeOptions) &&
            Array.isArray(config[excludeKey])
          ) {
            // type = mutiple
            let values = config[excludeKey];
            return values.some((value) => excludeOptions.indexOf(value) > -1);
          }

          if (
            Array.isArray(excludeOptions) &&
            excludeOptions.indexOf(config[excludeKey]) > -1
          ) {
            // type = single
            return true;
          }
        } else if (config[field]) {
          // type = boolean
          return true;
        }
      }
    }
  }
  return false;
}

function getDisabledOptions(param, config) {
  // config = {
  //   structure_select_1: "黑"
  //   structure_select_2: "夏芽卡"
  //   structure_select_3: "無"
  // }

  return param.options
    .filter((o) => {
      // format must be xxx[A,B];yyy[C] ....
      return checkIfDisabled(o, config);
    })
    .map((o) => o.name);
}

class ProductParam extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: null,
    };
  }

  componentDidMount() {
    this._getDefaultInputValue();
  }

  componentDidUpdate(prevProps) {
    let {value} = this.props;

    if (prevProps.value !== value) {
      this._getDefaultInputValue();
    }
  }

  render() {
    let {param, viewOnly} = this.props;

    if (!param) {
      return null;
    }

    if (viewOnly) {
      return <>{this._renderViewOnly()}</>;
    }

    return (
      <>
        {param.type === 'single' && this._renderSingle()}
        {param.type === 'multiple' && this._renderMultiple()}
        {param.type === 'number' && this._renderNumber()}
        {param.type === 'boolean' && this._renderBoolean()}
        {param.type === 'group-number' && this._renderQuantity()}
        {param.type === 'master' && this._renderMaster()}
      </>
    );
  }

  _getDefaultInputValue = () => {
    let {param, value} = this.props;
    if (param) {
      if (param.type === 'number') {
        this.setState({inputValue: value});
        return value;
      } else if (param.type === 'group-number') {
        this.setState({inputValue: value.quantity});
        return value.quantity;
      } else if (param.type === 'master') {
        this.setState({inputValue: value.quantity});
        return value.quantity;
      } else if (param.type === 'boolean') {
        this.setState({inputValue: value});
      }
    }
  };

  _renderViewOnly = () => {
    let {selectName, param, value} = this.props;

    param = filterParamOptionsWithSide({param, side: this.props.side});

    if (param.type === 'group-number') {
      return (
        <SelectRow className="view-only">
          <label>{param.label || selectName}</label>
          <div className="select-options">{`${value.name}-${value.quantity}`}</div>
        </SelectRow>
      );
    } else if (param.type === 'master') {
      return (
        <>
          <SelectRow className="view-only">
            <label>{param.label || selectName}</label>
            <div className="select-options">{`${value.material}`}</div>
          </SelectRow>
          <SelectRow className="view-only">
            <label>尺寸</label>
            <div className="select-options">{`${value.size}`}</div>
          </SelectRow>
          <SelectRow className="view-only">
            <label>數量</label>
            <div className="select-options">{`${value.quantity}`}</div>
          </SelectRow>
        </>
      );
    } else if (param.type === 'single') {
      const selectedOption = param.options.find((opt) => opt.name === value);
      if (selectedOption) {
        return (
          <SelectRow className="view-only">
            <label>{param.label || selectName}</label>
            <div className="select-options">
              {selectedOption.label || value}
            </div>
          </SelectRow>
        );
      }
    } else if (param.type === 'multiple') {
      const allSelections = value.reduce((v, acc) => {
        const selectedOption = param.options.find((opt) => opt.name === v);
        const selectedLabel = (selectedOption && selectedOption.label) || v;
        return `${acc} / ${selectedLabel}`;
      }, '');

      return (
        <SelectRow className="view-only">
          <label>{param.label || selectName}</label>
          <div className="select-options">{allSelections || '-'}</div>
        </SelectRow>
      );
    } else if (param.type === 'boolean') {
      return (
        <SelectRow className="view-only">
          <label>{param.label || selectName}</label>
          <div className="select-options">{value}</div>
        </SelectRow>
      );
    }

    return (
      <SelectRow className="view-only">
        <label>{param.label || selectName}</label>
        <div className="select-options">{value}</div>
      </SelectRow>
    );
  };

  _renderMaster = () => {
    let {selectName, param, value, setValue} = this.props;

    param = filterParamOptionsWithSide({param, side: this.props.side});

    const displayMap = {};

    for (const option of param.options) {
      displayMap[option.material] = option.label || option.material;
    }

    const selectedMasterOption = parseMasterOption(
      param.options.find((o) => o.material === value.material),
    );

    return (
      <>
        <SelectRow>
          <label>{param.label || selectName}</label>

          <div className="select-options">
            <DropdownSelector
              optionsArr={param.options.map((option) => option.material)}
              onChoiceClick={(choice) => setValue({...value, material: choice})}
              selectedOption={value.material}
              displayMap={displayMap}
            />
          </div>
        </SelectRow>

        <SelectRow>
          <label>尺寸</label>

          <div className="select-options">
            <DropdownSelector
              optionsArr={selectedMasterOption.sizeOptions}
              onChoiceClick={(choice) => setValue({...value, size: choice})}
              selectedOption={value.size}
            />
          </div>
        </SelectRow>

        <SelectRow>
          <label>數量</label>

          <div className="select-options">
            {selectedMasterOption.quantityOptions.map((option, idx) => {
              if (option.range_from === option.range_to) {
                return (
                  <OptionBtn
                    key={idx}
                    label={option.range_from}
                    selected={value.quantity === Number(option.range_from)}
                    onClick={() => {
                      this.setState({inputValue: null});
                      setValue({
                        ...value,
                        quantity: Number(option.range_from),
                      });
                    }}
                  />
                );
              }

              const selected = isRangeOptionSelected(value.quantity, option);
              const min = Number(option.range_from);
              const max = Number(option.range_to);
              // const inputStyle = selected
              //   ? {
              //       color: '#1890FF',
              //       borderColor: '#1890FF',
              //     }
              //   : {
              //       color: 'gray',
              //     };

              return (
                <div key={idx} style={{margin: 0, display: 'inline-block'}}>
                  <span style={{fontSize: 10, marginRight: 5}}>自訂</span>
                  <Input
                    key={idx}
                    type="number"
                    value={this.state.inputValue}
                    style={{maxWidth: 80}}
                    onChange={(e) => {
                      this.setState({inputValue: e.target.value});
                    }}
                    onBlur={() => {
                      if (this.state.inputValue) {
                        const nextValue = Number(this.state.inputValue);
                        if (min <= nextValue && nextValue <= max) {
                          setValue({
                            ...value,
                            quantity: nextValue,
                          });
                        } else {
                          if (nextValue > max) {
                            alert(
                              `該需求為特殊規格或數量，請來電洽詢或加入官方LINE專人詢價。`,
                            );
                          } else {
                            alert(`注意: 可用的自訂範圍介於${min}~${max}!`);
                          }

                          this.setState({inputValue: min});
                          setValue({
                            ...value,
                            quantity: min,
                          });
                        }
                        return;
                      }

                      this.setState({inputValue: null});
                    }}
                  />
                </div>
              );
            })}
          </div>
        </SelectRow>
      </>
    );
  };

  _renderSingle = () => {
    let {selectName, param, value, setValue, config} = this.props;

    param = filterParamOptionsWithSide({param, side: this.props.side});

    const displayMap = {};

    for (const option of param.options) {
      displayMap[option.name] = option.label || option.name;
    }

    let disabledArr = getDisabledOptions(param, config);

    return (
      <SelectRow>
        <label>{param.label || selectName}</label>

        <div className="select-options">
          <DropdownSelector
            optionsArr={param.options.map((option) => option.name)}
            onChoiceClick={(choice) => setValue(choice)}
            selectedOption={value}
            displayMap={displayMap}
            disabledArr={disabledArr}
          />
        </div>
      </SelectRow>
    );
  };

  _renderMultiple = () => {
    let {selectName, param, value, setValue, config} = this.props;

    param = filterParamOptionsWithSide({param, side: this.props.side});

    const displayMap = {};

    for (const option of param.options) {
      displayMap[option.name] = option.label || option.name;
    }

    let disabledArr = getDisabledOptions(param, config);

    return (
      <SelectRow>
        <label>{param.label || selectName}</label>

        <div className="select-options">
          <DropdownSelector
            multiple={true}
            optionsArr={param.options.map((option) => option.name)}
            multiSelectedArr={value}
            onChoiceClick={(choice) => {
              const selected = value && value.indexOf(choice) > -1;

              if (!value || !Array.isArray(value)) {
                value = [];
              } else {
                value = [...value];
              }

              if (!selected) {
                value.push(choice);
              } else {
                value.splice(value.indexOf(choice), 1);
              }

              setValue(value);
            }}
            displayMap={displayMap}
            disabledArr={disabledArr}
          />
        </div>
      </SelectRow>
    );
  };

  _renderNumber = () => {
    let {selectName, param, value, setValue} = this.props;

    param = filterParamOptionsWithSide({param, side: this.props.side});

    param.options = param.options.reduce((sum, o) => {
      // 1~1, 2~2, 3~5, 5~10, 10~10000 -> 1~1, 2~2, 3~10000
      if (o.range_from === o.range_to) {
        sum.push(o);
      } else {
        let last = sum.slice(-1)[0];

        if (!last || (last && last.range_from === last.range_to)) {
          sum.push(o);
        } else {
          sum[sum.length - 1].range_to = o.range_to;
        }
      }
      return sum;
    }, []);

    return (
      <SelectRow>
        <label>{param.label || selectName}</label>

        <div className="select-options">
          {param.options.map((option, idx) => {
            if (option.range_from === option.range_to) {
              return (
                <OptionBtn
                  key={idx}
                  label={option.range_from}
                  selected={value === Number(option.range_from)}
                  onClick={() => {
                    this.setState({inputValue: null});
                    setValue(Number(option.range_from));
                  }}
                />
              );
            }

            const selected = isRangeOptionSelected(value, option);
            const min = Number(option.range_from);
            const max = Number(option.range_to);
            // const inputStyle = selected
            //   ? {
            //       color: '#1890FF',
            //       borderColor: '#1890FF',
            //     }
            //   : {
            //       color: 'gray',
            //     };

            return (
              <div key={idx} style={{margin: 0, display: 'inline-block'}}>
                <span style={{fontSize: 10, marginRight: 5}}>自訂</span>
                <Input
                  key={idx}
                  type="number"
                  value={this.state.inputValue}
                  style={{maxWidth: 80}}
                  onChange={(e) => {
                    this.setState({inputValue: e.target.value});
                  }}
                  onBlur={() => {
                    if (this.state.inputValue) {
                      const nextValue = Number(this.state.inputValue);
                      if (min <= nextValue && nextValue <= max) {
                        setValue(nextValue);
                      } else {
                        if (nextValue > max) {
                          alert(
                            `該需求為特殊規格或數量，請來電洽詢或加入官方LINE專人詢價。`,
                          );
                        } else {
                          alert(`注意: 可用的自訂範圍介於${min}~${max}!`);
                        }

                        this.setState({inputValue: min});
                        setValue(min);
                      }
                      return;
                    }

                    this.setState({inputValue: null});
                  }}
                />
              </div>
            );
          })}
        </div>
      </SelectRow>
    );
  };

  _renderBoolean = () => {
    let {selectName, param, value, setValue, config} = this.props;

    let disabled = checkIfDisabled(param, config);

    return (
      <SelectRow>
        <label>{param.label || selectName}</label>

        <div className="select-options">
          <Switch
            checkedChildren="是"
            unCheckedChildren="否"
            disabled={disabled}
            defaultChecked={value}
            onChange={(checked) => setValue(checked)}
            style={{
              marginTop: 6,
              ...(disabled &&
                !!value && {backgroundColor: appConfig.colors.error}),
            }}
          />
        </div>
      </SelectRow>
    );
  };

  _renderQuantity = () => {
    let {selectName, param, value, setValue} = this.props;
    let groups = {};

    param = filterParamOptionsWithSide({param, side: this.props.side});

    for (let option of param.options) {
      groups[option.name] = true;
    }

    groups = Object.keys(groups);

    const {name: groupName, quantity} = value;
    const subOptions = param.options.filter(
      (option) => option.name === groupName,
    );

    return (
      <>
        <SelectRow>
          <label>商品款式</label>

          <div className="select-options">
            <DropdownSelector
              optionsArr={groups}
              onChoiceClick={(choice) => {
                if (choice !== groupName) {
                  setValue({
                    name: choice,
                    quantity: Number(
                      param.options.find((option) => option.name === choice)
                        .range_from,
                    ),
                  });
                }
              }}
              selectedOption={value.name}
            />
          </div>
        </SelectRow>

        <SelectRow>
          <label>{param.label || selectName}</label>

          <div className="select-options">
            {subOptions.map((option, idx) => {
              if (option.range_from === option.range_to) {
                return (
                  <OptionBtn
                    key={`${groupName}-${idx}`}
                    label={option.range_from}
                    selected={quantity === Number(option.range_from)}
                    onClick={() => {
                      this.setState({inputValue: null});
                      setValue({
                        name: groupName,
                        quantity: Number(option.range_from),
                      });
                    }}
                  />
                );
              }

              const selected = isRangeOptionSelected(quantity, option);
              const min = Number(option.range_from);
              const max = Number(option.range_to);
              // const inputStyle = selected
              //   ? {
              //       color: '#1890FF',
              //       borderColor: '#1890FF',
              //     }
              //   : {
              //       color: 'gray',
              //     };

              return (
                <div key={idx} style={{margin: 0, display: 'inline-block'}}>
                  <span style={{fontSize: 10, marginRight: 5}}>自訂</span>
                  <Input
                    key={idx}
                    type="number"
                    value={this.state.inputValue}
                    style={{maxWidth: 80}}
                    onChange={(e) => {
                      this.setState({inputValue: e.target.value});
                    }}
                    onBlur={() => {
                      if (this.state.inputValue) {
                        const nextValue = Number(this.state.inputValue);
                        if (min <= nextValue && nextValue <= max) {
                          setValue({
                            name: groupName,
                            quantity: nextValue,
                          });
                        } else {
                          if (nextValue > max) {
                            alert(
                              `該需求為特殊規格或數量，請來電洽詢或加入官方LINE專人詢價。`,
                            );
                          } else {
                            alert(`注意: 可用的自訂範圍介於${min}~${max}!`);
                          }

                          this.setState({inputValue: min});
                          setValue({
                            name: groupName,
                            quantity: min,
                          });
                        }
                        return;
                      }

                      this.setState({inputValue: null});
                    }}
                  />
                </div>
              );
            })}
          </div>
        </SelectRow>
      </>
    );
  };
}

function ProductSizeParam(props) {
  const {product, value, setValue, viewOnly} = props;
  const [inputValue, setInputValue] = useState(value || {});

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  if (viewOnly) {
    return (
      <SelectRow className="view-only">
        <label>商品尺寸</label>
        <div className="select-options">
          {product['length_select'].label} {value['length_select']} x{' '}
          {product['width_select'].label} {value['width_select']}
        </div>
      </SelectRow>
    );
  }

  return (
    <SelectRow>
      <label>商品尺寸</label>

      <div className="select-options">
        {/* <div
          style={{
            display: 'inline',
            padding: '4px 11px',
            marginRight: 10,
            color: '#aaa',
            border: 'solid 1px #D9D8DA',
          }}>
          {product.unit_length} x {product.unit_width}
        </div> */}

        {['length_select', 'width_select'].map((selectName, idx) => (
          <div style={{display: 'inline'}}>
            {idx !== 0 && ' x '}
            <span style={{fontSize: 10, marginRight: 5}}>
              {product[selectName].label || '自訂'}
            </span>
            <Input
              key={idx}
              type="number"
              value={inputValue[selectName]}
              style={{maxWidth: 80}}
              onChange={(e) => {
                const value = e.target.value;
                setInputValue((prev) => ({...prev, [selectName]: value}));
              }}
              onBlur={(e) => {
                const option = product[selectName].options[0];
                const min = option.range_from;
                const max = option.range_to;
                let nextValue = Number(e.target.value || 0);
                if (nextValue > max) {
                  alert(
                    `該需求為特殊規格或數量，請來電洽詢或加入官方LINE專人詢價。`,
                  );
                  nextValue = max;
                } else if (nextValue < min) {
                  alert(`注意: 可用的自訂範圍介於${min}~${max}!`);
                  nextValue = min;
                }

                setInputValue((prev) => ({
                  ...prev,
                  [selectName]: nextValue,
                }));
                setValue({[selectName]: nextValue});
              }}
            />
          </div>
        ))}
      </div>
    </SelectRow>
  );
}

const SelectRow = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  padding-bottom: 15px;

  & > label {
    font-weight: 500;
    flex-basis: 100px;
    padding-top: 6px;
    color: ${appConfig.colors.textSecond};
  }

  & > .select-options {
    flex: 1;
    min-width: 150px;
    color: ${appConfig.colors.text};
  }

  &.view-only {
    padding-bottom: 5px;
    & > label {
      padding-top: 0;
      color: ${appConfig.colors.textSecond};
    }
    & > .select-options {
      color: ${appConfig.colors.main};
    }
  }

  ${(props) => props.css || ''}
`;

export default ProductParam;
export {
  findExtraDisplayInfo,
  getDefaultConfigWithExtra,
  getProductSelectNames,
  SelectRow,
  ProductSizeParam,
  getDisabledOptions,
};
